module.exports = __webpack_public_path__ + "img/topFeature1.74b4551.png";